export default __webpack_public_path__ + "static/media/chevron-up.b8db2d27.svg";